export default {"src":"/_next/static/media/user-profile-icon-blue.aa13528f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};